import { useCallback } from 'react';
import type { Dispatch, SetStateAction } from 'react';
import { IconButton } from '@mui/material';

import { CloseIcon } from '@/assets/icons';
import { ClearButton } from '@/modules/common/components/inputs/types';

type Props = {
  clearButton: ClearButton
  onChange: (value: number) => void;
  setDraft: Dispatch<SetStateAction<string>>;
  setIsEditing: Dispatch<SetStateAction<boolean>>;
  onBlur?: (value: number) => void;
};

export default function NumberInputClearButton(props: Props) {
  const { clearButton, onChange, setDraft, setIsEditing, onBlur } = props;

  const preventMouseDownBlur = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
  }, []);

  const resetButton = useCallback(() => {
    onChange(clearButton.value);
    onBlur?.(clearButton.value);
    setDraft(clearButton.text);
    setIsEditing(false);
  }, [clearButton, onBlur, onChange, setDraft, setIsEditing]);

  return (
    <IconButton
      tabIndex={-1}
      onMouseDown={preventMouseDownBlur}
      onClick={resetButton}
      sx={{ p: 0.5 }}
    >
      <CloseIcon />
    </IconButton>
  );
}
